import { type FormEvent, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../lib/api';
import { ErrorBanner } from '../components/ui';

export function SignIn() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<unknown>(null);
  const [busy, setBusy] = useState(false);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await api.signIn(email, password);
      navigate('/dashboard', { replace: true });
    } catch (caught) {
      setError(caught);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="signin">
      <form onSubmit={submit}>
        <h1>NeteGate Central</h1>
        <p>Internal operations console</p>
        <ErrorBanner error={error} />
        <div className="field">
          <label htmlFor="email">Work email</label>
          <input
            id="email"
            type="email"
            autoComplete="username"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="field">
          <label htmlFor="password">Password</label>
          <input
            id="password"
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <button type="submit" disabled={busy}>
          {busy ? 'Signing in…' : 'Sign in'}
        </button>
      </form>
      <div className="qubow-footer muted" style={{ fontSize: '12px', textAlign: 'center', marginTop: '20px' }}>
        © 2026 Developed by <b><a href="https://www.qubow.com" target="_blank" aria-label="Qubow" style={{ color: 'inherit', textDecoration: 'none' }}>Qubow</a></b>
      </div>
    </div>
  );
}
